<div class="modal__outer_wrapper" *ngIf="toggle" >
    <div class="modal__overlay" (click)="toggleModal()"></div>
    <div class="modal__wrapper">
        <h3 *ngIf="name">{{name}}</h3>
        <div class="modal__content">
            <ng-content></ng-content>
        </div>
    </div>
</div>
